export const setupNudgePhrases = [
  'No polished plan needed. What’s one idea you’ve been kicking around?',
  'Tell me a little about what you do. We can figure out the next step together.',
  'Still exploring? Toss me a rough idea and we’ll brainstorm from there.',
  'Who would you love to work with? Start there, even if you’re not sure how to reach them.',
  'What’s one thing you’d like to make easier in your business?',
  'Big ambition or tiny next step—what would you like to move forward?',
  'What have you been putting off? We can break it into a first step.',
  'If your business could look different in six months, what would you change?',
  'A sentence, a half-formed thought, a “what if”—any of those is a place to start.',
] as const;

export function shuffledSetupNudges(previous: string | null): string[] {
  const phrases: string[] = [...setupNudgePhrases];
  for (let index = phrases.length - 1; index > 0; index -= 1) {
    const other = Math.floor(Math.random() * (index + 1));
    [phrases[index], phrases[other]] = [phrases[other]!, phrases[index]!];
  }
  // Each click shows a visibly different phrase.
  if (phrases[0] === previous) [phrases[0], phrases[1]] = [phrases[1]!, phrases[0]!];
  return phrases;
}
